import { render } from "./Additions.vue?vue&type=template&id=c72adf70&scoped=true"
import script from "./Additions.vue?vue&type=script&lang=js"
export * from "./Additions.vue?vue&type=script&lang=js"

import "./Additions.vue?vue&type=style&index=0&id=c72adf70&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c72adf70"]])

export default __exports__